module.exports = __webpack_public_path__ + "static/img/view-03-search@t.56e9f2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket/view-03-search@t.jpg
// module id = xly0
// module chunks = 0